<template>
  <!-- Метка источника маршрута, как «галочка» в соцсетях: зелёная - маршрут
       EcoWay (проверен), серая контурная - от пользователя (не проверен). -->
  <span class="inline-flex shrink-0 align-middle" :title="label" role="img" :aria-label="label" data-verified-mark :data-verified="verified">
    <BadgeCheck
      :size="size"
      :stroke-width="2"
      aria-hidden="true"
      :class="verified ? 'fill-primary text-white' : 'text-muted-foreground/60'"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { BadgeCheck } from "lucide-vue-next";

const props = withDefaults(defineProps<{ verified: boolean; size?: number }>(), { size: 18 });
const { t } = useI18n();
const label = computed(() => (props.verified ? t("routes.source.verified") : t("routes.source.unverified")));
</script>
